import { useTranslation } from 'react-i18next';
import seatInfoFormatter from '../../utils/formatters';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

export default function DesktopDrawer({ drawerWidth, seats, onRemove, onRemoveAll, onCancel, onContinue }) {
  const { t } = useTranslation();

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
        },
      }}
      variant="permanent"
      anchor="right"
    >
      {seats.length ? (
        <List sx={{ overflow: 'auto' }}>
          {seats.map(
            (
              { id, singleType, typeId, typeLabel, isDefaultType, section, row, seat, categoryLabel, categoryColor },
              index
            ) => (
              <ListItem sx={{ borderLeft: `5px solid ${categoryColor}` }} key={`${id}-${index}`} divider>
                <ListItemText
                  sx={{ maxWidth: 200 }}
                  primary={
                    <>
                      {categoryLabel}
                      {!isDefaultType && <Chip sx={{ maxWidth: 100, marginLeft: 1 }} size="small" label={typeLabel} />}
                    </>
                  }
                  secondary={seatInfoFormatter(section, row, seat, t)}
                />
                <ListItemSecondaryAction>
                  <Grid container justifyItems="center" alignItems="center">
                    <IconButton edge="end" aria-label="delete" onClick={() => onRemove(id, singleType ? null : typeId)}>
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                </ListItemSecondaryAction>
              </ListItem>
            )
          )}
          {!!seats.length && (
            <ListItem>
              <Button fullWidth variant="text" size="small" onClick={onRemoveAll}>
                {t('Clear')}
              </Button>
            </ListItem>
          )}
        </List>
      ) : (
        <Box sx={{ height: '100%' }} display="flex" alignItems="center" justifyContent="center">
          <Grid item>
            <Typography variant="h6">{t('No seat selected')}</Typography>
          </Grid>
        </Box>
      )}
      <Box sx={{ marginTop: 'auto' }}>
        <Divider />
        <List>
          <ListItem>
            <Button disabled={!seats.length} onClick={onContinue} fullWidth variant="contained" size="big">
              {`${seats.length} ${seats.length === 1 ? t('seat selected') : t('seats selected')}`}
            </Button>
          </ListItem>
          <ListItem>
            <Button onClick={onCancel} fullWidth variant="outlined" size="big">
              {t('Cancel')}
            </Button>
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );
}
